import { CrmOption } from '@touch4it/ng-swp/common';

import { UserModel } from '~/api/users/user.model';

export type SelectableUserRole = 'management' | 'staff';
export type UserRole = SelectableUserRole | 'admin';

export const selectableUserRoleOptions: CrmOption[] = ['management', 'staff'].map((r) => ({
  label: `users.role.${r}`,
  value: r,
}));

export type ExtendedUserRole = UserRole | 'guest' | 'basic';

export const getSelectableUserRole = (user: UserModel): SelectableUserRole | undefined => {
  const role = getUserRole(user);

  if (role === 'management' || role === 'staff') {
    return role;
  }

  return undefined;
};

export const canEditUserRole = (loggedInUser: UserModel, editedUser: UserModel): boolean => {
  const canEdit = loggedInUser.roles.admin === true || loggedInUser.roles.management === true;

  return canEdit && getSelectableUserRole(editedUser) !== undefined;
};

export const getUserRole = (user: UserModel): ExtendedUserRole => {
  if (user.roles.admin) {
    return 'admin';
  }

  if (user.roles.management) {
    return 'management';
  }

  if (user.roles.staff) {
    return 'staff';
  }

  if (user.roles.basic) {
    return 'basic';
  }

  return 'guest';
};
